import React, { useState, useContext } from 'react';
import AppContext from './AppContext';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from './components/Card';
import PokedexTable from './PokedexTable';
import PokedexSpriteGrid from './PokedexSpriteGrid';
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from './components/Tabs';

export enum TableView {
  Table,
  Pills,
  SpriteGrid,
}

const getAverageStatBlurb = (totalBaseSpecies: number, totalVariants: number): string => {
  if (totalBaseSpecies === 0 && totalVariants === 0) return 'No Pokémon selected';
  if (totalVariants === 0) return `${totalBaseSpecies} unique Pokémon`;
  return `${totalBaseSpecies} unique Pokémon (${totalBaseSpecies + totalVariants} counting variants)`;
};

function PokedexTableCard() {
  const {
    totalBaseSpecies,
    totalFilteredSpecies,
  } = useContext(AppContext);
  const [tableView, setTableView] = useState<TableView>(TableView.SpriteGrid);

  let table = null;
  if (tableView === TableView.Table) {
    table = <PokedexTable includeSprites isCompact={false} />;
  }
  if (tableView === TableView.SpriteGrid) {
    table = <PokedexSpriteGrid />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="min-w-full text-center">
          National Pokédex
        </CardTitle>
        <CardDescription className="min-w-full text-center">
          {getAverageStatBlurb(totalBaseSpecies, totalFilteredSpecies - totalBaseSpecies)}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="2" className="w-[400px] -mt-2 mb-4">
          <TabsList>
            <TabsTrigger onClick={() => setTableView(TableView.Table)} value="1">Table</TabsTrigger>
            <TabsTrigger onClick={() => setTableView(TableView.SpriteGrid)} value="2">Sprite Grid</TabsTrigger>
          </TabsList>
        </Tabs>
        {table}
      </CardContent>
    </Card>
  );
}

export default PokedexTableCard;
